module.exports = __webpack_public_path__ + "files/c36f96171ca0925b53c16fbc880584df.png";